import {useEffect, useState} from 'react'
import {TooltipWrapper} from '../../../components/Tooltip'
import {formatMask} from '../../../utils/formatMonetaryToBr'
import Select from 'react-select'
import {useFormik} from 'formik'
import {
  createInitialValues as initialValues,
  TitemRequest,
  TItemValidateForm,
} from './core/model/sale'
import {ISelect} from '../../../coreGlobal/models/default'
import Swal from 'sweetalert2'
import {reactSelectFilterCustomStyles} from '../../../utils/reactSelectFilterCustomStyles'
import {editUser, getUsers} from './core/_requests'
import {LoadingSpinner} from '../../../utils/loading/loadingSpinner'
import {buildUserRequest} from './buildUserRequest'
import useAuthorization from '../../../hooks/useAuthorization'

interface IItemSaleData {
  itemSaleData: any | null
  saleId: number
}

export const ItemSaleList = ({itemSaleData, saleId}: IItemSaleData) => {
  const [loading, setLoading] = useState(false)
  const [loadingUser, setLoadingUser] = useState(false)

  const [allUsers, setAllUsers] = useState<ISelect[] | undefined>([])
  const [handleToEditUser, setandleToEditUser] = useState<boolean>(false)
  const [initialSellers, setInitialSellers] = useState<any[]>([])

  const isAuthorizedToChangeSeller = useAuthorization('sales.change_seller')

  const formik = useFormik<TItemValidateForm>({
    initialValues: {
      ...initialValues,
      seller: [],
    },
    onSubmit: async (values) => {
      const valuesFilter = buildUserRequest(values)
      await submit(valuesFilter)
    },
  })

  useEffect(() => {
    if (itemSaleData?.length) {
      const sellersArray = itemSaleData.map((item: any) => ({
        value: item.seller?.id,
        label: item.seller?.name || '',
      }))

      const ItemsArray = itemSaleData.map((item: any) => item?.id)

      formik.setFieldValue('seller', sellersArray)
      formik.setFieldValue('product', ItemsArray)
    }
  }, [itemSaleData])

  const handleToEdit = async () => {
    setInitialSellers(formik.values.seller)
    setandleToEditUser(true)
    setLoadingUser(true)
    try {
      const dataUser = await getUsers()
      setAllUsers(dataUser)
    } catch (error: any) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: error?.response?.data?.message,
        showConfirmButton: true,
      })
    } finally {
      setLoadingUser(false)
    }
  }

  const handleCancelEdit = () => {
    formik.setFieldValue('seller', initialSellers)
    setandleToEditUser(false)
  }

  const submit = async (req: TitemRequest) => {
    await Swal.fire({
      title: 'Deseja atualizar o Usuário(s)?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
        cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        try {
          const data = await editUser(req, saleId)
          setandleToEditUser(false)
          await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Salvo com sucesso',
            showConfirmButton: false,
            timer: 1500,
          })
        } catch (error: any) {
          Swal.fire({
            icon: 'warning',
            title: 'Oops...',
            text: error.response.data.message,
            timer: 5000,
          })
        } finally {
          setLoading(false)
        }
      }
    })
  }

  return (
    <>
      <div className='card-header cursor-pointer'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0 me-5'>Informações do produto </h3>
          {isAuthorizedToChangeSeller && !handleToEditUser && (
            <TooltipWrapper tooltipText={'Editar'} tooltipPlacement={'top'}>
              <button
                className='btn btn-link btn-color-muted btn-active-color-danger'
                onClick={() => handleToEdit()}
              >
                <i className='ki-duotone ki-pencil me-5 fs-1'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              </button>
            </TooltipWrapper>
          )}
        </div>
      </div>
      <div className='card-body py-3'>
        {loading ? (
          <LoadingSpinner
            title='Salvando'
            style={{
              width: '2rem',
              height: '2rem',
              colorSpinner: '#f1416c',
              colorText: '#f1416c',
            }}
          />
        ) : (
          <div className='table-responsive'>
            <form onSubmit={formik.handleSubmit} noValidate className='form'>
              <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                <thead>
                  <tr className='fw-bold text-muted'>
                    <th className='min-w-150px'>Produto</th>
                    <th className='min-w-150px'>Usuário</th>
                    <th className='min-w-140px'>Sessões</th>
                    <th className='min-w-140px'>Agendadas</th>
                    <th className='min-w-140px'>Realizadas</th>
                    <th className='min-w-140px'>Canceladas</th>
                    <th className='min-w-140px'>Valor Unitário</th>
                    <th className='min-w-120px'>Preço</th>
                    <th className='min-w-120px'>Desconto</th>
                    <th className='min-w-120px'>Total</th>
                  </tr>
                </thead>

                <tbody>
                  {itemSaleData?.map((item, index) => {
                    return (
                      <tr key={`itemSaleInternal${index}`}>
                        <td>
                          <span className='text-dark fw-bold text-hover-danger fs-6'>
                            {item.product?.name}
                          </span>
                        </td>
                        <td>
                          {!handleToEditUser && (
                            <span className='text-dark fw-bold text-hover-danger fs-6'>
                              {formik?.values?.seller[index]?.label || '-'}
                            </span>
                          )}
                          {handleToEditUser &&
                            (loadingUser ? (
                              <LoadingSpinner
                                title='Carregando'
                                style={{
                                  width: '2rem',
                                  height: '2rem',
                                  colorSpinner: '#f1416c',
                                  colorText: '#f1416c',
                                }}
                              />
                            ) : (
                              <Select
                                id={`users-${index}`}
                                value={formik.values.seller[index] || null}
                                className='react-select-styled react-select-solid'
                                classNamePrefix='react-select'
                                onChange={(option) => {
                                  if (!option) return
                                  const updated = [...formik.values.seller]
                                  updated[index] = option
                                  formik.setFieldValue('seller', updated)
                                }}
                                styles={{
                                  ...reactSelectFilterCustomStyles,
                                  menuPortal: (base) => ({...base, zIndex: 9999}),
                                }}
                                menuPortalTarget={document.body}
                                menuPosition='fixed'
                                menuPlacement='top'
                                options={allUsers}
                                placeholder='Vendedor(a)'
                              />
                            ))}
                        </td>
                        <td>
                          <a
                            href='#'
                            className='text-dark fw-bold text-hover-danger d-block mb-1 fs-6 '
                          >
                            {item.sessions}
                          </a>
                        </td>
                        <td>
                          <span className='text-dark fw-bold text-hover-danger fs-6'>
                            {item.scheduledSessions}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-bold text-hover-danger fs-6'>
                            {item.sessionsRealized}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-bold text-hover-danger fs-6'>
                            {item.canceledSessions}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-bold text-hover-danger d-block mb-1 fs-6'>
                            {formatMask(item.product?.price)}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-bold text-hover-danger d-block mb-1 fs-6'>
                            {formatMask(item.price)}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-bold text-hover-danger d-block mb-1 fs-6'>
                            {formatMask(item.discount)}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-bold text-hover-danger d-block mb-1 fs-6'>
                            {formatMask(item.totalPrice)}
                          </span>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
              {handleToEditUser && (
                <div className='card-footer d-flex justify-content-end py-6 px-9'>
                  <button
                    type='reset'
                    className='btn btn-secondary me-2'
                    onClick={handleCancelEdit}
                  >
                    Cancelar
                  </button>
                  <button
                    type='submit'
                    className='btn btn-danger'
                    disabled={loading || !formik.isValid}
                  >
                    {!loading && 'Salvar'}
                    {loading && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Salvando...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                </div>
              )}
            </form>
          </div>
        )}
      </div>
    </>
  )
}
